import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    loading: false,
    isCompleted: false,
    messageCode: 0,
    errorMessage: ''
}
const addToCartSlice = createSlice({
    name: 'addToCart',
    initialState,
    reducers: {
        setCompleted: (state, action) => {
            state.isCompleted = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setMessageCode: (state, action) => {
            state.messageCode = action.payload;
        },
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload;
        }
    }
});

export const addToCartActions = addToCartSlice.actions;

export const addToCartSelector = (state: any) => state?.addToCart;

export default addToCartSlice.reducer;





